import React, { Component } from 'react';
import Request from 'superagent';

export default class StoreFilter extends Component {
  onChange(event) {
    this.props.onStoreChange(event.target.value);
  }
  render() {
    return (
      <select onChange={this.onChange.bind(this)} value={this.props.activeStoreFilter} className="form-control">
          {
            this.props.stores.map((store, index) => {
              return <option key={index} value={store.dms_id}>{store.dms_label}</option>
            })
          }
      </select>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/store-filter.js
 **/